// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2CWtD","icon":"index_icon_sFHiz","dropdownGray":"index_dropdownGray_2Qh1B","dropdownDark":"index_dropdownDark_3pz7j","title":"index_title_3LTjq"};